import { CountryData } from 'types/wellGuardian';

import { Units } from '../wir.constants';

export const getCurrencyUnit = (country: string) => {
  switch (country) {
    case CountryData.unitedKingdom:
      return Units.POUND;
    case CountryData.denmark:
      return Units.DKK;
    default:
      return Units.US_DOLLER;
  }
};
